(function () {
    'use strict';

    /**
     * Section registry - lets a page section own the loading of its data.
     * The page (EventCtrl) decides when a section is in view and calls load(),
     * the section registers the function that loads its data.
     * A load requested before the section registered waits for the registration.
     */
    angular
        .module('EventListApp')
        .service('SectionRegistry', sectionRegistry);

    sectionRegistry.$inject = ['$q'];

    function sectionRegistry($q) {
        const entries = {};

        /**
         * Register the loader of a section
         * @param {string} sectionId the section element id
         * @param {function} loadFn function (eventId, lang, pageData) returning a promise or nothing
         */
        this.register = function (sectionId, loadFn) {
            getEntry(sectionId).resolve(loadFn);
        };

        /**
         * Load the data of a section
         * @param {string} sectionId the section element id
         * @param {number} eventId
         * @param {number} lang
         * @param {object} [pageData] optional page level data a section needs (e.g. the event date)
         * @returns {Promise} resolved when the section finished loading
         */
        this.load = function (sectionId, eventId, lang, pageData) {
            return getEntry(sectionId).promise.then(function (loadFn) {
                return loadFn(eventId, lang, pageData);
            });
        };

        function getEntry(sectionId) {
            if (!entries[sectionId])
                entries[sectionId] = $q.defer();

            return entries[sectionId];
        }
    }
})();
